exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".page-link{color:#c70000}.page-item.active .page-link{background-color:#c70000;border-color:#c70000}.page-link:focus,.page-link:hover{color:#c70000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-69d67871","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/src/pages/Produtos.vue
// module id = 62
// module chunks = 0